const header = document.querySelector('.header');
const scrollThreshold = 80;

window.addEventListener('scroll', () => {
    const shouldStick = window.scrollY > scrollThreshold;
    header.classList.toggle('header--sticky', shouldStick);
    header.classList.toggle('shadow-md', shouldStick);
});
